import { useQuery } from "react-query";
import api from "../services/api";
import { useActiveCompany } from "./useActiveCompany";
import { useActiveUser } from "./useActiveUser";

export const useNotificationsFields = () => {
  const userId = useActiveUser();
  const activeCompany = useActiveCompany();

  return useQuery(
    [`notifications-fields-${userId}-${activeCompany}`, userId, activeCompany],
    () => api.fetchNotificationsFields(userId || -1, activeCompany || -1),
    {
      enabled: !!userId && !!activeCompany,
    }
  );
};
